"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var base_1 = __importDefault(require("./base"));
var dev_1 = __importDefault(require("./dev"));
var prod_1 = __importDefault(require("./prod"));
var getConfig = function (env) {
    if (env === void 0) { env = 'development'; }
    return (0, lodash_1.merge)(base_1.default, !(0, lodash_1.isString)(env) || env.indexOf('development') >= 0 ? dev_1.default : {}, (0, lodash_1.isString)(env) && env.indexOf('production') !== -1 ? prod_1.default : {});
};
var config = getConfig(process.env.REACT_APP_CONFIG || process.env.NODE_ENV);
console.log({ config: config });
exports.default = config;
